import type {} from "@lit/react";
import { ContextMenuListBox as ContextMenuListBoxElement, } from "@vaadin/context-menu/vaadin-context-menu-list-box.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { ContextMenuListBoxElement };
export type ContextMenuListBoxEventMap = Readonly<{}>;
const events = {} as ContextMenuListBoxEventMap;
export type ContextMenuListBoxProps = WebComponentProps<ContextMenuListBoxElement, ContextMenuListBoxEventMap>;
export const ContextMenuListBox = createComponent({
    elementClass: ContextMenuListBoxElement,
    events,
    react: React,
    tagName: "vaadin-context-menu-list-box",
});
